import { render } from "./FeatureFlags.vue?vue&type=template&id=06ea4d03"
import script from "./FeatureFlags.vue?vue&type=script&lang=js"
export * from "./FeatureFlags.vue?vue&type=script&lang=js"

import "./FeatureFlags.vue?vue&type=style&index=0&id=06ea4d03&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__